/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetAttributesBucketName200Response
 */
export interface GetAttributesBucketName200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetAttributesBucketName200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetAttributesBucketName200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * Clear-text person attributes as key-value pairs. Attribute names (keys) may be at most 70 bytes long. Attribute values must be JSON-serializable and are limited to 64KiB.
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetAttributesBucketName200Response
     */
    result?: { [key: string]: any; };
}

/**
 * Check if a given object implements the GetAttributesBucketName200Response interface.
 */
export function instanceOfGetAttributesBucketName200Response(value: object): value is GetAttributesBucketName200Response {
    return true;
}

export function GetAttributesBucketName200ResponseFromJSON(json: any): GetAttributesBucketName200Response {
    return GetAttributesBucketName200ResponseFromJSONTyped(json, false);
}

export function GetAttributesBucketName200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttributesBucketName200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'] == null ? undefined : json['result'],
    };
}

export function GetAttributesBucketName200ResponseToJSON(json: any): GetAttributesBucketName200Response {
    return GetAttributesBucketName200ResponseToJSONTyped(json, false);
}

export function GetAttributesBucketName200ResponseToJSONTyped(value?: GetAttributesBucketName200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': value['result'],
    };
}

